import { TextField, styled } from "@mui/material";

const GvTextField = styled(TextField)(({ theme }) => ({
  "label + &": {
    marginTop: "1.5rem", // 24px converted to rem
    marginBottom: 0,
  },
  "& .MuiInputBase-root": {
    backgroundColor: "#fff",
    borderRadius: "0.5rem", // 8px converted to rem
    marginBottom: "0 !important",
  },
  "& .MuiInputBase-root .MuiInputBase-input": {
    "fontSize": "0.8125rem", // 13px converted to rem
    "padding": "0.6875rem 0.75rem", // 11px 12px converted to rem
    "caretColor": theme.palette.primary.main,
    "borderRadius": "0.5rem", // 8px converted to rem

    "&:focus": {
      borderColor: "transparent",
    },
  },
  "& .MuiFormHelperText-root": {
    marginLeft: "0rem", // 0px converted to rem
    marginBottom: "-0.625rem", // -10px converted to rem
  },
  "& .MuiInputBase-root .MuiOutlinedInput-notchedOutline": {
    borderColor: "transparent",
  },
  "& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "transparent",
  },
  "& .MuiInputBase-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
    borderColor: "transparent",
  },
  "& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: `0.0625rem solid ${theme.palette.primary.main}`,
  },
  // "& .MuiInputBase-root.Mui-focused ": {
  //   border: "transparent",
  // },
  // "& .MuiInputBase-root.Mui-error": {
  //   borderRadius: "0.5rem", // 8px converted to rem
  //   backgroundColor: theme.palette.error.light,
  // },
  // "& .MuiInputBase-root.Mui-error input": {
  //   borderRadius: "0.5rem", // 8px converted to rem
  //   backgroundColor: theme.palette.error.light,
  // },
  // "& .MuiInputBase-root.Mui-error .MuiOutlinedInput-notchedOutline": {
  //   border: `0.0625rem solid ${theme.palette.error.main}`,
  // },
  "& .MuiInputBase-root .MuiInputBase-inputMultiline": {
    padding: 0,
  },
}));

export default GvTextField;
